import { formComponents as fc } from "@/features/i18n/formComponents";
import { ui } from "@patient-watch/ui";
import { toast } from "@patient-watch/ui/use-toast";
import useSetRoleMutation from "@/features/auth/hooks/useSetRoleMutation";
import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import * as z from "zod";

const FormSchema = z.object({
    role: z.enum(["PATIENT", "CLINICIAN"], {
        required_error: "You need to select a notification type.",
    }),
});

function Role() {
    const form = useForm<z.infer<typeof FormSchema>>({
        resolver: zodResolver(FormSchema),
    });

    const setRoleMutation = useSetRoleMutation();

    function onSubmit(data: z.infer<typeof FormSchema>) {
        setRoleMutation.mutate(data);
        toast({
            title: "You submitted the following values:",
            description: (
                <pre className="bg-slate-950 mt-2 p-4 rounded-md w-[340px]">
                    <code className="text-white">{JSON.stringify(data, null, 2)}</code>
                </pre>
            ),
        });
    }

    return (
        <ui.Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6 mx-auto py-6">
                <ui.FormField
                    control={form.control}
                    name="role"
                    render={({ field }) => (
                        <ui.FormItem className="space-y-3">
                            <ui.FormLabel>Sign up as a</ui.FormLabel>
                            <ui.FormControl>
                                <ui.RadioGroup
                                    onValueChange={field.onChange}
                                    defaultValue={field.value}
                                    className="flex flex-col space-y-1"
                                >
                                    <ui.FormItem className="flex items-center space-x-3 space-y-0 bg-white p-4 border border-indigo-100 rounded-md text-lg">
                                        <ui.FormControl>
                                            <ui.RadioGroupItem value="PATIENT" />
                                        </ui.FormControl>
                                        <ui.FormLabel className="font-normal">Patient</ui.FormLabel>
                                    </ui.FormItem>
                                    <ui.FormItem className="flex items-center space-x-3 space-y-0 bg-white p-4 border border-indigo-100 rounded-md text-lg">
                                        <ui.FormControl>
                                            <ui.RadioGroupItem value="CLINICIAN" />
                                        </ui.FormControl>
                                        <ui.FormLabel className="font-normal">Clinician</ui.FormLabel>
                                    </ui.FormItem>
                                </ui.RadioGroup>
                            </ui.FormControl>
                            <ui.FormMessage />
                        </ui.FormItem>
                    )}
                />
                <fc.SubmitButton />
            </form>
        </ui.Form>
    );
}

export const Route = createFileRoute("/_app/role")({
    component: Role,
});
